import {
    type AssignVesselToTagReq,
    type CreateVesselTagReq,
    type UpdateVesselTagReq,
    type VesselTag,
    type VesselTagResponse,
} from '../../../api/vessels/types/vessel-tag'
import {type LocationIdType} from '../locations/state'
import {type ErrorObject} from './types/error-object'

export type LocationTagArrayMapType = Map<LocationIdType, Array<VesselTagResponse>>
export interface VesselTagReduxState {
    isFetchingTags: boolean
    vesselTags: VesselTag[]
    tagsForLocation: LocationTagArrayMapType
    errorResult: ErrorObject | undefined
    displayVesselSettingsForId: LocationIdType | undefined
    tagToCreateOrAssign: CreateVesselTagReq | AssignVesselToTagReq | null
    tagToUpdate: UpdateVesselTagReq | null
    searchedTerm: string
}

export const DEFAULT_VESSEL_TAGS_STATE: VesselTagReduxState = {
    isFetchingTags: true,
    vesselTags: new Array<VesselTag>(),
    tagsForLocation: new Map<LocationIdType, Array<VesselTagResponse>>(),
    errorResult: undefined,
    displayVesselSettingsForId: undefined,
    tagToCreateOrAssign: null,
    tagToUpdate: null,
    searchedTerm: '',
}
